import React from 'react';
import PropTypes from'prop-types';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import {FormattedMessage} from 'react-intl';

class Login extends React.Component {
    constructor(props) {
        super(props);
        this.handleForgotPassword.bind(this);
    }

    handleForgotPassword = () => {
        this.props.handleForgotPassword();
    };

    handleKeyPress = (event) => {
        if (event.key === "Enter") {
            this.props.handleLogin();
        }
    };

    render() {
        return (
            <div>
                <div className="login-wrapper">
                    <div className="login-fields">
                        <h3>{<FormattedMessage id="login.title"/>}
                            <a className="forgotPasswordLink" onClick={this.handleForgotPassword}>{<FormattedMessage id="login.forgotPassword"/>}</a>
                        </h3>
                        <TextField
                            id="email"
                            type="email"
                            floatingLabelText={<FormattedMessage id="general.email"/>}
                            floatingLabelFixed={true}
                            fullWidth={true}
                            onChange={this.props.handleInputChange}
                            onKeyPress={this.handleKeyPress}
                        />
                        <TextField
                            id="password"
                            type="password"
                            floatingLabelText={<FormattedMessage id="general.password"/>}
                            floatingLabelFixed={true}
                            fullWidth={true}
                            onChange= {this.props.handleInputChange}
                            onKeyPress = {this.handleKeyPress}
                        />
                        <div className="pt20">
                            <RaisedButton
                                label={<FormattedMessage id="login.buttonLabel"/>}
                                primary={true} fullWidth={true}
                                keyboardFocused={true}
                                onTouchTap = {() => this.props.handleLogin()}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

Login.PropTypes  = {
    handleInputChange: PropTypes.func.isRequired,
    handleLogin: PropTypes.func.isRequired
};

export default Login;



// WEBPACK FOOTER //
// ./src/pages/login/login.component.js